export default {
    GO_TO_HOME_PAGE: 'Go to home page',
    GO_TO_PREV_PAGE: 'Go to previous page',
};
